<template>
  <div
    class="header"
    :class="{ 'wisdom-community-header': isWisdomCommunityScreen }"
  >
    <div class="logo">
      <h1
        v-if="currentRoute === 'MainDashboard' || currentRoute === 'CommunityOverview' || currentRoute === 'WisdomCommunityScreen'"
        style="display: inline-block; vertical-align: middle;"
      >
        智慧社区综合管理平台
      </h1>
    </div>
    <div class="navigation">
      <el-button 
        v-for="(item, index) in navItems" 
        :key="index" 
        :type="currentRoute === item.name ? 'primary' : 'default'"
        @click="navigateTo(item.name)"
      >
        {{ item.title }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentRoute: {
      type: String,
      required: true
    },
    isWisdomCommunityScreen: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const navItems = [
]
    
    const navigateTo = (routeName) => {
      if (routeName !== props.currentRoute) {
        emit('routeChanged', routeName)
      }
    }
    
    return {
      navItems,
      navigateTo
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 20px;
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  border: none;
  color: white;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

/* 智慧社区大屏页面的特殊标题样式 */
.header.wisdom-community-header {
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  border: none;
  overflow: hidden;
}

.header.wisdom-community-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, rgba(24, 144, 255, 0.8), transparent);
  animation: borderGlow 3s infinite;
}

@keyframes borderGlow {
  0% { background-position: -100% 0; }
  100% { background-position: 100% 0; }
}

.logo {
  display: flex;
  align-items: center;
}

.logo h1 {
  margin: 0;
  font-size: 32px;
  color: white;
}

.navigation {
  display: flex;
  gap: 10px;
}

/* 确保按钮有足够的点击区域 */
.el-button {
  padding: 10px 20px;
  cursor: pointer;
}
</style>
.header {
  color: white;
}